import React from "react";
import logoImg from "../../../assets/images/marriott-logo.png";
import signatureImg from "../../../assets/images/Marriot-logo-signature.png";
import styles from "./Header.module.css";

export const Header = () => {
  return (
    <div className={styles.desktopHeader}>
      <img
        className={styles.desktopSignatureLogo}
        src={signatureImg}
        alt="Marriott logo"
      />
      <a
        href="https://www.marriott.com/default.mi"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className={styles.desktopLogo} src={logoImg} alt="Marriott logo" />
      </a>
    </div>
  );
};
